import Konva from "konva";
import { DMCWeb } from "../KObjects/DMCWeb";

// TOOLS
const rectangleTool = require("./RectangleTool");

export class Web extends rectangleTool.Rectangle {
  constructor() {
    super();
    this.name = "Web";
    this.urlWeb = "";
    this.isFullscreen = true;
    this.currentMousePosDown = "";
  }

  createControllerObject(name, konvaObject) {
    return new DMCWeb(name, konvaObject, this.urlWeb, this.isFullscreen);
  }

  createNew(controllerProject) {
    const currentMousePos = controllerProject.collectCurrentMousePosition();
    this.currentShapeConfig = {};
    this.currentShapeConfig.scaleX = 1;
    this.currentShapeConfig.scaleY = 1;
    this.currentShapeConfig.x = Math.round(currentMousePos.x / controllerProject.scale);
    this.currentShapeConfig.y = Math.round(currentMousePos.y / controllerProject.scale);
    this.currentShapeConfig.fill = controllerProject.mainColor;
    this.currentShapeConfig.stroke = controllerProject.secondaryColor;
    this.currentShapeConfig.strokeWidth = 5;
    this.currentShapeConfig.draggable = true;

    this.currentShapeConfig.dragBoundFunc = function (pos) {
      if (!controllerProject.canObjectMove) {
        return {
          x: this.absolutePosition().x,
          y: this.absolutePosition().y,
        };
      } else {
        return {
          x: pos.x,
          y: pos.y,
        };
      }
    };

    this.currentObject = this.createNewForm();
    controllerProject.addElementToCurrentLayer(this.currentObject);
    this.currentShapeConfig = this.currentObject.attrs;
  }

  createTransformer(elementToTransform) {
    const transformer = super.createTransformer(elementToTransform);
    return transformer;
  }

  /**
   * @function createNewForm()
   * @description Called after mouseDown of the area draw
   */
  createNewForm() {
    let rect = new Konva.Rect(this.currentShapeConfig);
    rect.opacity(0.5);
    return rect;
  }

  web(url) {
    this.urlWeb = url;
  }

  static(data) {
    this.isFullscreen = data;
  }

  setContent(data) {
    this.web(data.url);
    this.static(data.isFullscreen);
  }

  setConfig(edit) {
    this.edit = edit;
  }

  editNewElement(controllerProject) {
    this.createNew(controllerProject);
    this.currentObject.setAttr("x", this.edit.x);
    this.currentObject.setAttr("y", this.edit.y);
    this.currentObject.setAttr("width", this.edit.width);
    this.currentObject.setAttr("height", this.edit.height);
    this.currentObject.setAttr("scaleX", this.edit.scaleX);
    this.currentObject.setAttr("scaleY", this.edit.scaleY);
    this.edit = "";
    return this.mouseUp(controllerProject);
  }

  mouseDown(controllerProject) {
    this.currentMousePosDown = controllerProject.collectCurrentMousePosition();
    this.createNew(controllerProject);
    this.origin.x = controllerProject.collectCurrentMousePosition().x / controllerProject.scale;
    this.origin.y = controllerProject.collectCurrentMousePosition().y / controllerProject.scale;

    if (!this.interval) {
      this.interval = setInterval(() => {
        const currentMousePos = controllerProject.collectCurrentMousePosition();
        const distanceX = Math.round(Math.abs(this.origin.x - currentMousePos.x / controllerProject.scale));
        const distanceY = Math.round(Math.abs(this.origin.y - currentMousePos.y / controllerProject.scale));

        if (currentMousePos.x / controllerProject.scale < this.origin.x) {
          this.currentObject.setAttr("x", Math.round(currentMousePos.x / controllerProject.scale));
        }
        if (currentMousePos.y / controllerProject.scale < this.origin.y) {
          this.currentObject.setAttr("y", Math.round(currentMousePos.y / controllerProject.scale));
        }
        if (controllerProject.shiftKeyPressed) {
          let length = distanceX > distanceY ? distanceY : distanceX;
          length = Math.round(length);
          this.currentObject.setAttr("width", length);
          this.currentObject.setAttr("height", length);
        } else {
          this.currentObject.setAttr("width", distanceX);
          this.currentObject.setAttr("height", distanceY);
        }
        this.updateCurrentOptions(
          this.currentObject.getAttr("x"),
          this.currentObject.getAttr("y"),
          this.currentObject.getAttr("width"),
          this.currentObject.getAttr("height")
        );
      }, 30);
    }
  }
}
